export default {
      id: "icon-phone-usage",
      viewBox: "0 0 10.75 16.13",
      url: __webpack_public_path__ + "Assets/Sprite.svg#icon-phone",
      toString: function () {
        return this.url;
      }
    }